import React from 'react';
import TextField from '../../../../components/form/text-field';
import ISDNMigrationTable from '../isdn-migration-table/isdn-migration-table';
import SummaryDetails from '../summary-details/summary-details';
import FormError from '../../../../components/form/error/error';
import './isdn-service-details.css';

import {
  PORT_TYPE_P_PHONE,
  PORT_TYPE_ANALOG,
  PORT_TYPE_MOBILE,
} from '../../../../app-constants';

const ISDNServiceDetails = (props) => {
  const
    {
      handlePhoneCountChange,
      handlePhoneCountBlur,
      siteServices,
      onMigrationCheckBoxChange,
      migrationAdvertiseChecks,
      siteId,
      migrationCounts,
      migrationCountErrors,
      formSubmitted,
      siteReviewed,
      inDial,
    } = props;
  const {
    isdnServiceDetails,
    serviceDetailsHeadingText,
    tableHeadings,
    phoneAndDevicesHeading,
    phoneAndDevicesDescription,
  } = props.authorableContent;

  const siteServicesArray = [];

  siteServices.forEach((parentService) => {
    siteServicesArray.push({ type: parentService.type, number: parentService.number });

    if (parentService.primaryList && parentService.primaryList.length > 0) {
      parentService.primaryList.forEach((childService) => {
        siteServicesArray.push({ type: 'PrimaryFNN', number: childService.number });

        childService.auxList.forEach((auxService) => {
          siteServicesArray.push({ type: 'Auxillary', number: auxService });
        });
      });
    } else {
      parentService.auxList.forEach((auxService) => {
        siteServicesArray.push({ type: 'Auxillary', number: auxService });
      });
    }
  });

  const showZeroError = (valueToCheck) => {
    const pPhoneValue = migrationCounts[`${siteId}-${PORT_TYPE_P_PHONE}`] !== undefined ?
      migrationCounts[`${siteId}-${PORT_TYPE_P_PHONE}`] : -1;
    const analogValue = migrationCounts[`${siteId}-${PORT_TYPE_ANALOG}`] !== undefined ?
      migrationCounts[`${siteId}-${PORT_TYPE_ANALOG}`] : -1;
    const mobileValue = migrationCounts[`${siteId}-${PORT_TYPE_MOBILE}`] !== undefined ?
      migrationCounts[`${siteId}-${PORT_TYPE_MOBILE}`] : -1;

    return parseInt(pPhoneValue, 10) === valueToCheck && parseInt(analogValue, 10) === valueToCheck && parseInt(mobileValue, 10) === valueToCheck;
  };

  return (
    <div className="isdn-service-section">
      {inDial === false &&
        <React.Fragment>
          <div className="row">
            <div className="col-12 pl-sm-0">
              <h2 id="service-heading" className="service-heading">{serviceDetailsHeadingText}</h2>
            </div>
          </div>

          <ISDNMigrationTable
            siteServicesArray={siteServicesArray}
            onCheckBoxChange={onMigrationCheckBoxChange}
            isdnServiceDetails={isdnServiceDetails}
            tableHeadings={tableHeadings}
            migrationAdvertiseChecks={migrationAdvertiseChecks}
            siteId={siteId}
          />

        </React.Fragment>
      }
      <SummaryDetails summaryTitle={phoneAndDevicesHeading} summaryText={phoneAndDevicesDescription} />

      <div className="row migration-count-section" id="migration-count-section">
        <div className={`col-md-6 pl-sm-0 ${migrationCountErrors[`${siteId}-${PORT_TYPE_P_PHONE}`] ? 'has-error' : ''}`}>
          <div className="block-spacer">
            <TextField
              label={isdnServiceDetails.formFields.noOfPhoneUsers.label}
              id={`${siteId}-${PORT_TYPE_P_PHONE}`}
              value={migrationCounts[`${siteId}-${PORT_TYPE_P_PHONE}`] ? migrationCounts[`${siteId}-${PORT_TYPE_P_PHONE}`] : ''}
              onChange={handlePhoneCountChange}
              onBlur={handlePhoneCountBlur}
              placeholder={isdnServiceDetails.formFields.noOfPhoneUsers.placeholder}
            />
          </div>
          {migrationCountErrors
            && migrationCountErrors[`${siteId}-${PORT_TYPE_P_PHONE}`]
            && <FormError errorText={isdnServiceDetails.formFields.noOfPhoneUsers.errorText} />}
        </div>
        <div className={`col-md-6 pl-sm-0 ${migrationCountErrors[`${siteId}-${PORT_TYPE_MOBILE}`] ? 'has-error' : ''}`}>
          <div className="block-spacer">
            <TextField
              label={isdnServiceDetails.formFields.noOfMobileUsers.label}
              id={`${siteId}-${PORT_TYPE_MOBILE}`}
              value={migrationCounts[`${siteId}-${PORT_TYPE_MOBILE}`] ? migrationCounts[`${siteId}-${PORT_TYPE_MOBILE}`] : ''}
              onChange={handlePhoneCountChange}
              onBlur={handlePhoneCountBlur}
              placeholder={isdnServiceDetails.formFields.noOfMobileUsers.placeholder}
            />
          </div>
          {migrationCountErrors
            && migrationCountErrors[`${siteId}-${PORT_TYPE_MOBILE}`]
            && <FormError errorText={isdnServiceDetails.formFields.noOfMobileUsers.errorText} />}
        </div>
        <div className={`col-md-6 pl-sm-0 ${migrationCountErrors[`${siteId}-${PORT_TYPE_ANALOG}`] ? 'has-error' : ''}`}>
          <div className="block-spacer">
            <TextField
              label={isdnServiceDetails.formFields.noOfAnalogDevices.label}
              id={`${siteId}-${PORT_TYPE_ANALOG}`}
              value={migrationCounts[`${siteId}-${PORT_TYPE_ANALOG}`] ? migrationCounts[`${siteId}-${PORT_TYPE_ANALOG}`] : ''}
              onChange={handlePhoneCountChange}
              onBlur={handlePhoneCountBlur}
              placeholder={isdnServiceDetails.formFields.noOfAnalogDevices.placeholder}
            />
          </div>
          {migrationCountErrors
            && migrationCountErrors[`${siteId}-${PORT_TYPE_ANALOG}`]
            && <FormError errorText={isdnServiceDetails.formFields.noOfAnalogDevices.errorText} />}
        </div>
        {siteReviewed === false && showZeroError(0) &&
          <FormError errorText={isdnServiceDetails.devicesErrorText} />
        }
        {formSubmitted && (showZeroError(0)) &&
          <FormError errorText={isdnServiceDetails.devicesErrorText} />
        }
        {formSubmitted && showZeroError(-1) &&
          <FormError errorText={isdnServiceDetails.devicesErrorText} />
        }
        {siteReviewed && (showZeroError(0)) &&
          <FormError errorText={isdnServiceDetails.devicesErrorText} />
        }
      </div>
    </div>
  );
};

export default React.memo(ISDNServiceDetails);
